<!-- 开箱结果弹窗（含进度条 + 终极大奖） -->
<template lang="pug">
.reward-popup-mask(
  v-if="visible"
  @click.self="handleClose"
  @touchmove.prevent
  v-platform-expose="popupExpose"
)
  .popup-container(:style="{ backgroundImage: `url(${bgUrl})` }")
    .popup-time(
      v-if="styleType === 'close'"
      :style="{ visibility: popupCountdownText ? 'visible' : 'hidden' }"
    ) {{ popupCountdownText || '00分00秒后' }}
    .popup-title(
      :class="styleType === 'open' ? 'mt-open' : 'mt-close'"
    ) {{ styleType === 'open' ? '累计获得宝箱奖励' : '开启下一个宝箱'}}
    .popup-reward(
      v-if="styleType === 'open'"
    )
      span.popup-reward-number {{ todayTotalReward }}
      span.popup-reward-text 奖励金
    .popup-treasures
      .treasure-tip 今日宝箱无限领
      .treasure-items
        template(v-for="(item,index) in treasureList")
          .treasure-item(:class="{ opened: item.status === 'OPENED' }")
            .treasure-item-box(:class="getBoxClass(item, index)")
              .treasure-item-countdown(
                v-if="showItemCountdown(item)"
              ) {{ progressCountdownText }}
              img.box-img(
                :src="getProgressImg(item)"
                :class="{'last-img': index === treasureList.length - 1}"
              )
              span.box-amount {{ getBoxAmount(item, index) }}
            .treasure-item-progress
              .progress-line-left(
                :class="{ hidden: index === 0, 'disabled-color': item.status === 'LOCKED' }"
              )
              .progress-circle(
                :class="{'disabled-color': item.status === 'LOCKED'}"
              )
              .progress-line-right(
                :class="getLineRightClass(item, index)"
              )
            .treasure-item-index {{ getItemIndex(item, index) }}
    .popup-btn(
      @click="handleExtraReward"
      :class="{'disabled': !canContinue && !countdownEnded}"
    )
      img.video-icon(
          v-if="!countdownEnded"
          src="https://m.hellobike.com/6bbed8d0_play.png"
      )
      span.btn-text {{ displayButtonText }}
    img.popup-close(
      src="https://m.hellobike.com/ca36acbe_close_popup.png"
      @click="handleClose"
    )
</template>

<script>
import SPM from '../../../common/spm';

export default {
  name: 'RewardPopup',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    todayTotalReward: {
      type: Number,
      default: 0,
    },
    treasureList: {
      type: Array,
      default: () => [],
    },
    styleType: {
      type: String,
      default: 'close',
    },
    buttonText: {
      type: String,
      default: '看视频额外领奖励金',
    },
    parentCountdownText: {
      type: String,
      default: '',
    },
    canContinue: {
      type: Boolean,
      default: true,
    },
    strategyCode: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      hadCountdown: false,
    };
  },
  computed: {
    bgUrl() {
      return this.styleType === 'open'
        ? 'https://m.hellobike.com/43442ab9_new_open_bg.png'
        : 'https://m.hellobike.com/11480d79_close_popup.png';
    },
    popupCountdownText() {
      if (!this.parentCountdownText) return '';
      const [minutes = '00', seconds = '00'] = this.parentCountdownText.split(':');
      return `${minutes}分${seconds}秒后`;
    },
    progressCountdownText() {
      return this.parentCountdownText;
    },
    // CURRENT 宝箱是否在倒数第一或倒数第二位置
    isCurrentAtTail() {
      const len = this.treasureList.length;
      const currentIdx = this.treasureList.findIndex((item) => item.status === 'CURRENT');
      return currentIdx >= len - 2;
    },
    // 倒计时是否已结束（曾有倒计时且现在为空）
    countdownEnded() {
      return this.hadCountdown && !this.parentCountdownText;
    },
    // 按钮展示文案
    displayButtonText() {
      return this.countdownEnded ? '开宝箱' : this.buttonText;
    },
  },
  watch: {
    parentCountdownText(val) {
      if (val) this.hadCountdown = true;
    },
    visible(val) {
      if (!val) this.hadCountdown = false;
    },
  },
  methods: {
    getBusinessInfo() {
      const currentIndex = this.treasureList.findIndex(
        (item) => item.status === 'CURRENT',
      );
      const currentBox = this.treasureList[currentIndex] || {};

      return {
        subtitle: this.styleType === 'open' ? `${this.todayTotalReward}奖励金` : this.popupCountdownText,
        contenttitle: this.styleType === 'open' ? '累计获得宝箱奖励' : '开启下一个宝箱',
        boxAwardName: this.getBoxAmount(currentBox, currentIndex),
        boxSequence: currentBox.index,
        btnStatus: this.canContinue ? '1' : '2',
        boxgamecode: this.strategyCode,
        clk_name: this.displayButtonText,
      };
    },
    popupExpose() {
      // 宝箱曝光
      SPM.moduleExpose({
        moduleId: 'platform_boxgame_popup',
        contentId: 'platform_boxgame_popup',
        businessInfo: this.getBusinessInfo(),
      });
    },
    handleClose() {
      SPM.clickButton({
        buttonName: 'platform_box_game_close',
        businessInfo: this.getBusinessInfo(),
      });
      this.$emit('close');
    },
    getItemIndex(item, index) {
      if (item.status === 'OPENED' || item.status === 'CURRENT') {
        return `第${item.index}个`;
      }
      if (this.isCurrentAtTail) return `第${item.index}个`;
      const len = this.treasureList.length;
      if (index === len - 2) return '...';
      return '第?个';
    },
    getLineRightClass(item, index) {
      return {
        hidden: index === this.treasureList.length - 1,
        'disabled-color': item.status === 'CURRENT'
          || item.status === 'LOCKED',
      };
    },
    showItemCountdown(item) {
      return this.styleType === 'open'
        && item.status === 'CURRENT'
        && !!this.progressCountdownText;
    },
    // 进度条宝箱项 class
    getBoxClass(item, index) {
      return {
        last: index === this.treasureList.length - 1,
        opened: item.status === 'OPENED',
        active: item.status === 'CURRENT',
      };
    },
    // 进度条宝箱项显示金额
    getBoxAmount(item, index) {
      const isEdge = index === 0 || index === this.treasureList.length - 1;
      if (isEdge) return item.amount;
      if (this.isCurrentAtTail) return item.amount;
      return '???';
    },
    // 获取进度区宝箱图片
    getProgressImg(item) {
      return item.status === 'OPENED' ? item.prizeIcon : item.unPrizeIcon;
    },
    // 领取额外奖励
    handleExtraReward() {
      SPM.clickButton({
        buttonName: 'platform_boxgame_btn',
        businessInfo: this.getBusinessInfo(),
      });
      if (this.countdownEnded) {
        this.$emit('open-box');
        return;
      }
      if (!this.canContinue) return;
      this.$emit('claim-extra');
    },
  },
};
</script>

<style lang="less" scoped>
.reward-popup-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;

  .popup-container {
    width: 2.75rem;
    min-height: 4.07rem;
    background-size: 100% auto;
    background-repeat: no-repeat;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    box-sizing: border-box;

    .popup-time {
      margin-top: 1.42rem;
      color: #ff5c0a;
      font-weight: 600;
      font-size: 22px;
      line-height: 22px;
      letter-spacing: 0;
      text-align: center;
    }

    .popup-title {
      font-weight: 600;
      font-size: 20px;
      line-height: 20px;
      letter-spacing: 0;
      text-align: center;
      background: linear-gradient(89.23deg, #000 1.03%, #ab6f00 99%);
      -webkit-background-clip: text;
      background-clip: text;
      -webkit-text-fill-color: transparent;
    }

    .mt-open {
      margin-top: 1.35rem;
    }

    .mt-close {
      margin-top: 0.08rem;
    }

    .popup-reward {
      margin-top: 0.08rem;

      .popup-reward-number {
        color: rgba(255, 92, 10, 1);
        font-weight: 700;
        font-size: 36px;
        line-height: 36px;
        letter-spacing: 0;
        text-align: center;
        font-family: 'DIN Alternate Bold', sans-serif;
      }

      .popup-reward-text {
        color: rgba(255, 92, 10, 1);
        font-weight: 500;
        font-size: 14px;
        line-height: 14px;
        letter-spacing: 0;
        text-align: center;
      }
    }

    .popup-treasures {
      margin-top: 0.1rem;
      display: flex;
      flex-direction: column;
      background: #fff;
      border-radius: 0.12rem;
      padding: 0.08rem;

      .treasure-tip {
        color: #6c747a;
        font-weight: 400;
        font-size: 12px;
        line-height: 12px;
        letter-spacing: 0;
      }

      .treasure-items {
        display: flex;
        flex-direction: row;
        margin-top: 0.16rem;

        .treasure-item {
          flex: 1;
          display: flex;
          flex-direction: column;
          align-items: center;

          .treasure-item-box {
            position: relative;
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 0.51rem;
            height: 0.5rem;
            border-radius: 0.04rem;
            background: rgba(252, 244, 227, 1);

            .box-img {
              margin-top: 0.05rem;
              width: 0.28rem;
              height: 0.25rem;
            }

            .last-img {
              width: 0.38rem;
              height: 0.27rem;
            }

            .box-amount {
              margin-top: 0.01rem;
              color: rgba(255, 92, 10, 1);
              font-weight: 700;
              font-size: 14px;
              line-height: 14px;
              text-align: center;
              font-family: 'DIN Alternate Bold', sans-serif;
            }

            .treasure-item-countdown {
              position: absolute;
              top: -0.1rem;
              width: 0.4rem;
              height: 0.14rem;
              background: linear-gradient(90deg, #ff7349 0%, #ff6a64 100%);
              border-radius: 0.12rem;
              color: #fff;
              font-weight: 400;
              font-size: 0.12rem;
              text-align: center;
              line-height: 0.14rem;
            }
          }

          .treasure-item-progress {
            margin-top: 0.1rem;
            display: flex;
            flex-direction: row;
            align-items: center;

            .progress-line-left {
              width: 0.25rem;
              height: 0.01rem;
              background: rgba(255, 83, 37, 1);
            }

            .progress-circle {
              background: rgba(255, 83, 37, 1);
              width: 0.06rem;
              height: 0.06rem;
              border-radius: 50%;
              margin-left: 0.01rem;
              margin-right: 0.01rem;
            }

            .progress-line-right {
              width: 0.25rem;
              height: 0.01rem;
              background: rgba(255, 83, 37, 1);
            }

            .disabled-color {
              background: rgba(255, 83, 37, 0.5);
            }
          }

          .treasure-item-index {
            margin-top: 0.08rem;
            font-weight: 400;
            font-size: 12px;
            line-height: 12px;
            letter-spacing: 0;
            text-align: center;
            color: rgba(135, 144, 153, 1);
          }

          .hidden {
            visibility: hidden;
          }

          .last {
            background: linear-gradient(180deg, #ffd643 0%, #fcf2bb 100%);
          }
        }

        .opened {
          .treasure-item-box {
            opacity: 0.5;
          }
        }

        .active {
          border: 0.01rem solid #ff5523;
        }
      }
    }

    .popup-btn {
      margin-top: 0.09rem;
      width: 2.22rem;
      height: 0.44rem;
      border-radius: 0.12rem;
      display: flex;
      align-items: center;
      justify-content: center;
      background: linear-gradient(90deg, #ff5523 0%, #ff3e36 100%);
      color: rgba(255, 255, 255, 1);

      &.disabled {
        background: #cfcfcf;
        color: #fff;
        pointer-events: none;
      }

      .video-icon {
        width: 0.2rem;
        height: 0.2rem;
      }

      .btn-text {
        margin-left: 0.04rem;
      }
    }

    .popup-close {
      position: absolute;
      top: 0.41rem;
      right: 0;
      width: 0.32rem;
      height: 0.32rem;
    }
  }
}
</style>
